import { injectable, inject } from 'inversify'

import { PimService } from '#Products/services/PimService'
import { usePimStore } from '#Products/store/pimStore'

@injectable()
export class PimSupport {
  protected store: ReturnType<typeof usePimStore>

  constructor(@inject(PimService) protected service: PimService) {
    this.store = usePimStore()
  }

  async loadAttributes() {
    if (this.store.attrs) {
      return this.store.attrs
    }

    this.store.attrs = await this.service.attributesList()

    return this.store.attrs
  }

  async loadCategories() {
    if (this.store.categories) {
      return this.store.categories
    }

    this.store.categories = await this.service.categoriesList()

    return this.store.categories
  }

  loadPim() {
    return Promise.all([this.loadAttributes(), this.loadCategories()])
  }
}
